import { render, staticRenderFns } from "./LayananRS.vue?vue&type=template&id=3f40c58f"
import script from "./LayananRS.vue?vue&type=script&lang=js"
export * from "./LayananRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports